import { FC } from 'react';
import { Button, ButtonSizes, ButtonStyles } from '@silverfort/sf-components';

interface Props {
    onDiscard: () => void;
    onClose: () => void;
}

const DiscardChangesFooter: FC<Props> = ({ onDiscard, onClose }) => {
    return (
        <div className="flex justify-end items-center gap-2">
            <Button
                onClick={onClose}
                buttonSize={ButtonSizes.Medium}
                buttonStyle={ButtonStyles.GhostSolid}
                text={'No, Cancel'}
            />
            <Button
                onClick={onDiscard}
                buttonSize={ButtonSizes.Medium}
                buttonStyle={ButtonStyles.PrimarySolid}
                text={'Yes, Discard'}
            />
        </div>
    );
};

export default DiscardChangesFooter;
